module.exports = __webpack_public_path__ + "static/img/direct_hit_movie_thum_04_no_btn.9a2dcfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/movie/direct_hit_movie_thum_04_no_btn.jpg
// module id = Jk5m
// module chunks = 0